webpackJsonp([206061371186326],{

/***/ 1294:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"RecurrenceEditScope","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":"Update this and all future appointments in the series.","isDeprecated":false,"name":"ALL_OCCURRENCES"},{"deprecationReason":null,"description":"Update this single appointment occurrence only.","isDeprecated":false,"name":"THIS_OCCURRENCE"}],"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---enum-recurrence-edit-scope-946b6fae18d0310ae468.js